export const faq = {
    title: '常见问题',
    titleStaking: ' 购买 INO 的条件是什么？',
    subTitleStaking:
        '通过INO轮次购买NFT，需要进行以下步骤：<br> <br>' +
        '<b>第一步</b>：在以下下载 AIS 应用程序：<br>' +
        "- Android: <a href=' https://ste.sbgroup.finance/apk/ste-app-release-v2.apk'> https://ste.sbgroup.finance/apk/ste-app-release-v2.apk</a><br>" +
        "- iOS: <a href='https://testflight.apple.com/join/xaFDhi6Y'>https://testflight.apple.com/join/xaFDhi6Y</a><br><br>" +
        '<b>第二步</b>：用户根据指示进行KYC，将收到确认<br>' +
        '只有经过 KYC 验证的账户才有资格参与 INO 回合。',
    titleStakingHold: '<b>2. 买NFT有什么用？</b>',
    subTitleStakingHold:
        '在INO以$250/NFT的售价购买原版NFT时，玩家每天只需锻炼3分钟即可赚取$15。 ' +
        '投资回收期仅需 20 天，30 天可赚取高达 450 美元.<br><br>' +
        '此外，极具吸引力的NFT mint 机制，从1对NFT（男+女）可以创造出7个NFT孩子。' +
        '通过每天 5 分钟的常规锻炼，玩家可以立即轻松赚取至少 $2700/30 天甚至更多。<br>' +
        '利润是您最初投资的许多倍.<br><br>',
    titleStakingInformation: '<b>3. 什么是 AIS token？</b>',
    subTitleStakingInformation:
        'AIS 是 Stretch-to-Earn 的代表代币，与 SB 连接以围绕此应用创建实用程序。<br>' +
        '请看看AIS token的基本信息：<br>' +
        '- 符号: AIS<br>' +
        '- 总供应量: 10,000,000',
    titleInterestAfter: '<b>4. 当我需要帮助时，我可以联系谁？</b>',
    subTitleInterestAfter: '如需咨询，请联系： <a>info@dragonsb.finance</a>',
    titleNotReceivingInterest: '<b>5. 我在哪里可以了解更多关于 AIS 的信息？</b>',
    subTitleNotReceivingInterest:
        '请访问我们的博客以了解更多关于 AIS 的信息<br>' +
        '- 关于 $AIS: <a href="https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/">https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/</a><br>' +
        '- 关于 AIS 的机制和经济: <a href="https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/"> https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/</a><br>',
};
